import {
  Breadcrumb,
  Button,
  ErrorAlert,
  LinkIcon,
  PageHero,
  danger,
  success,
  useCustomForm,
  useFetchData,
} from "@";
import { defaultValues } from "./utils/validation";
import { getServicesConnection, saveServicesConnection } from "./utils/api";
import ServiceCard from "./components/ServiceCard";

/* ---------- Brand marks (no external assets) ---------- */

const GtmMark = () => (
  <span className="text-[11px] font-black tracking-tight">GTM</span>
);

const HotjarMark = () => (
  <span className="font-black tracking-tight">
    <span className="text-[15px]">Hj</span>
  </span>
);

/* ---------- Service definitions ---------- */

const SERVICES = [
  {
    key: "gtm",
    name: "Google Tag Manager",
    tagline:
      "إدارة شيفرات التحليلات والتتبع (GA4، إعلانات جوجل، بكسلات...) من حاوية واحدة.",
    docsHref:
      "https://support.google.com/tagmanager/answer/6103696?hl=ar",
    accent: {
      bg: "bg-blue-50",
      text: "text-blue-700",
      ring: "ring-blue-100",
      dot: "bg-blue-500",
    },
    brandMark: <GtmMark />,
    fields: [
      {
        name: "googleTagManagerHead",
        label: "شيفرة <head>",
        hint: "تُلصق داخل وسم <head>. تحتوي عادةً على dataLayer وحاوية الـ GTM.",
        placeholder:
          "",
        rows: 8,
      },
      {
        name: "googleTagManagerBody",
        label: "شيفرة <body>",
        hint: "تُلصق مباشرة بعد فتح وسم <body> — لدعم المتصفحات التي عطّلت JavaScript.",
        placeholder:
          "",
        rows: 8,
      },
    ],
  },
  {
    key: "hotjar",
    name: "Hotjar",
    tagline:
      "تتبّع سلوك الزوّار عبر الخرائط الحرارية وتسجيلات الجلسات والاستبيانات.",
    docsHref:
      "https://help.hotjar.com/hc/en-us/articles/115011867948-Installing-the-Hotjar-Tracking-Code",
    accent: {
      bg: "bg-orange-50",
      text: "text-orange-700",
      ring: "ring-orange-100",
      dot: "bg-orange-500",
    },
    brandMark: <HotjarMark />,
    fields: [
      {
        name: "hotjarScriptHeader",
        label: "شيفرة التتبع",
        hint: "تُلصق داخل وسم <head>. الشيفرة الكاملة من إعدادات حسابك في Hotjar.",
        placeholder:
          "",
        rows: 8,
      },
    ],
  },
];

const Index = () => {
  const links = [
    { name: "الاعدادات", link: "/all-settings" },
    { name: "ربط الخدمات", link: "" },
  ];

  const {
    reset,
    watch,
    errors,
    register,
    handleSubmit,
    isSubmitting,
  } = useCustomForm(defaultValues);

  const { error, fetchData } = useFetchData({
    reset,
    fun: getServicesConnection,
  });

  const submit = async (data) => {
    try {
      await saveServicesConnection(data);
      success("تم حفظ الإعدادات");
    } catch (err) {
      danger("تعذّر حفظ الإعدادات. حاول مرة أخرى.");
    }
  };

  // Count configured services for the hero badge + footer bar
  const configuredCount = SERVICES.filter((service) =>
    service.fields.some(
      (f) => (watch(f.name) || "").trim().length > 0,
    ),
  ).length;

  return (
    <>
      <ErrorAlert reload={fetchData} show={error} />
      <Breadcrumb links={links} />

      <main className="relative">
        <PageHero
          eyebrow="الإعدادات / ربط الخدمات"
          title="خدمات التحليلات والتتبع"
          icon={LinkIcon}
          count={`${configuredCount}/${SERVICES.length}`}
        />

        <p className="mb-6 max-w-2xl px-1 text-sm leading-relaxed text-gray-600 dark:text-gray-400">
          أضِف شيفرات أدوات التحليلات والتتبع لمتجرك. كل خدمة مستقلة — يمكنك
          تفعيل خدمة أو أكثر، وستُحقن شيفراتها تلقائياً في صفحات المتجر بعد
          الحفظ.
        </p>

        <form onSubmit={handleSubmit(submit)}>
          {SERVICES.map((service, idx) => (
            <ServiceCard
              key={service.key}
              serviceKey={service.key}
              name={service.name}
              tagline={service.tagline}
              accent={service.accent}
              brandMark={service.brandMark}
              docsHref={service.docsHref}
              fields={service.fields}
              register={register}
              watch={watch}
              errors={errors}
            />
          ))}

          {/* Sticky save bar */}
          <div className="floating-btn">
             
            <Button
              type="submit"
              title="حفظ الإعدادات"
              isLoading={isSubmitting}
            />
          </div>
        </form>
      </main>
    </>
  );
};

export default Index;
